import { InputGroupField } from 'cwp-components/forms'
import React, { ChangeEvent, useCallback, useEffect } from 'react'
import { BsSearch } from 'react-icons/bs'
import {
  useGlossaryTemplate,
  TAB_LISTS,
} from 'common/hooks/useGlossaryTemplate'
import { background } from 'assets/backgrounds'

const LegalTermsGlossary = () => {
  const {
    selectedTab,
    setSelectedTab,
    searchValue,
    onFilterBySearch,
    results,
    loadGlossaryTerms,
  } = useGlossaryTemplate()

  const handleSearchInputChange = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      onFilterBySearch(evt.target.value)
    },
    [],
  )

  useEffect(loadGlossaryTerms, [loadGlossaryTerms])

  return (
    <>
      <div className='md:m-[120px_240px_0px] m-[40px_20px] text-center space-y-[24px] '>
        <h1 className='md:text-[64px] text-[32px] text-[#001A3D] font-bold '>
          Legal Terms Glossary
        </h1>
        <p className='md:text-[18px] text-[16px] text-[#25395C] font-bold '>
          Welcome to our Legal Terms Glossary.
        </p>
        <p className='md:text-[18px] text-[16px] text-[#25395C] font-bold '>
          This page is designed to help you understand common legal terms used
          in England and Wales. Each term is explained in simple,
          straightforward language to make it easier to understand your rights
          and the legal process.
        </p>
        <p className='text-[#25395C] md:text-[16px] text-[12px]'>
          <span className='block'>
            This glossary is a resource to help you understand legal terminology
            often encountered in England and Wales.
          </span>
          It’s here to support you, whether you’re exploring legal information
          or involved in a legal process.
        </p>
      </div>

      <div className='md:m-[80px_240px_0px] m-[40px_20px] space-y-[40px]'>
        <div className='flex max-sm:flex-wrap md:gap-[16px] justify-center'>
          {TAB_LISTS.map((list, key) => (
            <span
              onClick={() => setSelectedTab(list)}
              key={`glossary-tab-${key}`}
              className={`p-[4px_10px]  font-bold ${
                key === 0 ? 'mr-[20px]' : 'w-[33px]'
              } hover:bg-[#D3D3FF] rounded-[4px] cursor-pointer ${
                selectedTab === list && 'bg-[#D3D3FF]'
              }`}
            >
              {list}
            </span>
          ))}
        </div>
        <InputGroupField
          className='md:w-[800px] mx-auto'
          Icon={BsSearch}
          placeholder='Search a legal term'
          reverse
          onChange={handleSearchInputChange}
          value={searchValue}
        />
      </div>

      <div className='md:p-[71px_111px] p-[40px_20px] relative md:space-y-[80px] space-y-[24px] '>
        <img
          className='absolute right-0 top-[50px] md:top-[71px] md:w-[231.747px] w-[100px] z-[-2]'
          src={background.Glossary._01}
          alt=''
        />
        <img
          className='absolute right-0 top-[50%] md:w-[131.747px] w-[100px] z-[-2]'
          src={background.Glossary._02}
          alt=''
        />
        <img
          className='absolute right-0 bottom-0 md:w-[231.747px] w-[100px] z-[-2]'
          src={background.Glossary._03}
          alt=''
        />
        {results &&
          results.map((term, key) => (
            <div
              key={`glossary-list-${key}`}
              className='md:space-y-[24px] space-y-[16px]'
            >
              <h1 className='md:text-[32px] text-[18px] font-bold text-[#5858DF] '>
                {term.group}
              </h1>

              {term.children.map((doc) => (
                <div>
                  <h1 className='md:text-[24px] text-[16px] text-[#7B7BDF] font-bold '>
                    {doc?.term}
                  </h1>
                  <p className='md:text-[16px] text-[12px] '>
                    {doc.definition}
                  </p>
                </div>
              ))}
            </div>
          ))}
      </div>
    </>
  )
}

export default LegalTermsGlossary
